/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{*[Symbol.iterator](){let s=this.next();for(;s;)yield s,s=this.next()}}class t extends s{}export{s as G,t as O};
